import {Input} from '@logistics-frontend/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import {Controller, useFormContext} from '@yandex-delivery/form'
import React from 'react'

import {CommentInputProps} from './CommentInput.types'

export function CommentInput({name}: CommentInputProps): React.ReactElement {
  const t = useI18n()
  const {control} = useFormContext()

  return (
    <Controller
      control={control}
      defaultValue=""
      name={name}
      render={({field, fieldState}) => (
        <div ref={field.ref}>
          <Input
            autoCapitalize="none"
            autoComplete="__disable-autocomplete"
            error={fieldState.invalid}
            helperText={fieldState.error?.message}
            label={t('cargo.create.address.comment', 'Комментарий для курьера')}
            name={name}
            onBlur={field.onBlur}
            onChange={field.onChange}
            size="l"
            spellCheck="false"
            value={field.value?.toString()}
            variant="line"
          />
        </div>
      )}
    />
  )
}
